export const setupOnboarding = {
  piezas: {
    confirmacion: { etiqueta: "Confirmación", larga: "Confirmación de reserva", porque: "Se está usando el ajuste general de tu cuenta, no uno propio de este alojamiento." },
    bienvenida: { etiqueta: "Bienvenida", larga: "Mensaje de bienvenida", porque: "Ahora mismo se envía el mensaje de bienvenida por defecto, que no es el tuyo." },
    checkin: { etiqueta: "Check-in", larga: "Envío del check-in", porque: "Ahora mismo se envía a la hora por defecto, que puede no ser la que te conviene." },
    horas: { etiqueta: "Horarios", larga: "Hora de entrada y salida", porque: "Sin tus horarios, cuando el huésped pregunta se le responde con los de por defecto." },
    cerradura: { etiqueta: "Acceso", larga: "Cerradura y acceso", porque: "El huésped llega a la puerta y no sabe cómo abrir." },
    servicios: { etiqueta: "Servicios", larga: "Servicios del alojamiento", porque: "Ni el motor de reservas ni el agente saben qué ofreces." },
    politicas: { etiqueta: "Normas", larga: "Políticas y normas", porque: "El huésped acepta unas normas por defecto, no las tuyas." },
  },
  titular: {
    listo: "Ya está todo preparado",
    unoAMedias: "Tu alojamiento está a medio configurar",
    variosAMedias: "Tus alojamientos están a medio configurar",
    casi: "Te queda poco para terminar",
  },
  consecuencia: {
    bienvenida: "Mientras tanto tus huéspedes reciben el mensaje de bienvenida por defecto, que no es el tuyo.",
    cerradura: "Mientras tanto hay huéspedes que llegarían a la puerta sin saber cómo abrir.",
    politicas: "Mientras tanto tus huéspedes aceptan unas normas por defecto, no las tuyas.",
    generico: "Mientras tanto se usan los ajustes por defecto, no los tuyos.",
  },
  explicacion: {
    listoUno: "Tu alojamiento ya puede recibir huéspedes.",
    listoVarios: "Tus {n} alojamientos ya pueden recibir huéspedes.",
    ajustesFinos: "Los ajustes finos —tarifas, canales, experiencias— los tienes cuando quieras en cada anuncio.",
    faltaUno: "Falta 1 alojamiento por terminar.",
    faltanVarios: "Faltan {n} alojamientos por terminar.",
  },
  resumen: {
    unAlojamiento: "1 alojamiento",
    nAlojamientos: "{n} alojamientos",
    unoPorPreparar: "1 por preparar",
    nPorPreparar: "{n} por preparar",
    listos: "{listos} listos",
  },
  anillo: {
    rotulo: "configurado",
    ariaCorta: "{n}% configurado",
    ariaLarga: "{n}% de la configuración completada",
  },
  cifras: {
    listos: "listos ·",
    ajustes: "ajustes hechos",
    ariaAjustes: "{hechas} de {total} ajustes hechos",
    marcador: "{hechas} de {total}",
  },
  ventana: {
    titulo: "¿Cerrar este aviso?",
    texto: "Dejará de aparecer en el panel, aunque te quede algo por configurar.",
    notaAntes: "Lo recuperas cuando quieras desde",
    notaRuta: "Personalizar → Mostrar el aviso de configuración",
    cancelar: "Cancelar",
    ocultar: "Cerrar",
  },
  acciones: {
    verQueFalta: "Ver qué falta",
    buscar: "Buscar alojamiento",
    sinResultados: "Ningún alojamiento pendiente se llama así.",
    verClaro: "Ver en claro",
    verOscuro: "Ver en oscuro",
    ampliar: "Ampliar",
    ampliarAria: "Ampliar el aviso",
    minimizar: "Minimizar",
    minimizarAria: "Minimizar el aviso",
    entendido: "Entendido",
    entendidoAria: "Entendido, cerrar el aviso",
    ocultar: "Cerrar",
    ocultarAria: "Cerrar el aviso de configuración",
    empezar: "Empezar",
    continuar: "Continuar",
    hecho: "hecho",
    teToca: "Te toca:",
    unidades: "{n} unidades",
  },
};
